const box = (val: any) =>
    (Array.isArray(val) ? val : [val]).filter((val) => val !== undefined);

export default box;